/**
 * Route-based breadcrumbs (Home / <Section> / <Page>).
 * Labels are humanised from the URL segment; a small overrides map handles
 * segments that don't follow simple title-case (e.g. abbreviations we need
 * to preserve later on service/industry slugs).
 */
const OVERRIDES = {
  "how-we-work": "How We Work",
  "why-choose-us": "Why Choose Us",
  "quality-compliance": "Quality & Compliance",
  "privacy-policy": "Privacy Policy",
  "terms-of-use": "Terms of Use",
  "cookie-policy": "Cookie Policy",
  // Services
  "quality-inspection": "Quality Inspection",
  "quality-assurance-quality-control": "Quality Assurance & Quality Control",
  "conformity-assessment-support": "Conformity Assessment Support",
  "logistics-management": "Logistics Management",
  "supply-chain-solutions": "Supply-Chain Solutions",
  "medical-laboratory-equipment-supply": "Medical & Laboratory Equipment Supply",
  // Industries
  "import-export": "Import & Export",
  "healthcare-laboratories": "Healthcare & Laboratories",
  "food-consumer-goods": "Food & Consumer Goods",
  "construction-infrastructure": "Construction & Infrastructure",
  "energy-industrial-operations": "Energy & Industrial Operations",
  "agriculture-agribusiness": "Agriculture & Agribusiness",
  "humanitarian-development": "Humanitarian & Development",
  "government-public-institutions": "Government & Public Institutions",
  "wholesale-distribution": "Wholesale & Distribution",
  "education-research": "Education & Research",
  // Top-level plurals
  "services": "Services",
  "industries": "Industries",
  "resources": "Resources",
  "medical-laboratory": "Medical Laboratory",
  "request-a-quote": "Request a Quote",
  "news": "News",
  "gallery": "Gallery",
  "contact": "Contact",
  "about": "About",
  "values": "Values",
};

function humanise(seg) {
  if (OVERRIDES[seg]) return OVERRIDES[seg];
  return seg
    .split("-")
    .map((s) => (s.length === 0 ? s : s[0].toUpperCase() + s.slice(1)))
    .join(" ");
}

/**
 * Build a breadcrumb trail for a route. Always starts with `Home`.
 * Home page returns [] (no breadcrumb).
 */
export function buildBreadcrumbs(pathname) {
  const clean = (pathname || "/").split("?")[0].split("#")[0];
  if (clean === "/" || clean === "") return [];
  const segs = clean.split("/").filter(Boolean);
  const items = [{ label: "Home", href: "/" }];
  let acc = "";
  segs.forEach((seg, i) => {
    acc += "/" + seg;
    items.push({ label: humanise(seg), href: i === segs.length - 1 ? null : acc });
  });
  return items;
}
